module.exports = __webpack_public_path__ + "static/media/3x3 L.1517aa3d.kra";